import { AUTHORIZED_ROUTES_WL } from 'common/constants/routing.constants';
import { MINUTE } from 'common/constants/time.constants';
import { millisecondsToMinutes } from 'common/utils/time.util';
import { resetAnalytics } from 'common/utils/client-analytics.util';
import Cookies from 'js-cookie';
import { COOKIES } from 'common/constants/cookies.constants';
import { COMMON_MODAL_IDS } from 'common/constants/modal.constants';
import { stores } from 'stores';
import { when } from 'mobx';

class AuthService {
  init() {
    when(
      () => stores.AuthStore.authToken && stores.AuthStore?.session?.exp,
      () => {
        const intervalId = setInterval(() => {
          const timeLeft = stores.AuthStore?.session?.exp * 1000 - Date.now();
          console.log(`checking session status, ${millisecondsToMinutes(timeLeft)} minutes left`);
          if (
            timeLeft <= MINUTE * 2
                || (!Cookies.get(COOKIES.authToken)
                    && !AUTHORIZED_ROUTES_WL.includes(window.location.pathname))
          ) {
            stores.ModalStore.push(COMMON_MODAL_IDS.SESSION_EXPIRED);
            clearInterval(intervalId);
          }
        }, MINUTE);
      },
    );
  }
}

export const authService = new AuthService();
